import { Navigate, useParams } from "react-router-dom";
import { toPublicCorridorSlug } from "@/data/corridors/corridorSeoSlugs";
import { ROUTE_PATHS } from "./routePaths";

/** `/route/:slug` and `/corridor/:slug` → `/routes/:publicSlug` */
export function LegacyCorridorRedirect() {
  const { slug } = useParams<{ slug: string }>();
  if (!slug) return <Navigate to={ROUTE_PATHS.POPULAR_ROUTES} replace />;
  return <Navigate to={`${ROUTE_PATHS.INTERCITY_ROUTES}/${toPublicCorridorSlug(slug)}`} replace />;
}
